import gql from "graphql-tag";
import { StarrableFieldsFragment } from "components/engagement/star/graphql/StarrableFieldsFragment";
import IndicatorFieldsFragment from "components/financials/modern/graphql/fragments/IndicatorFieldsFragment";

export default gql`
  fragment FinancialsTemplateFields on FinancialsTemplate {
    id
    _id
    objectId
    createdAt
    lastUpdatedAt
    name
    description
    isNativeTemplate
    isFundamenteiTemplate
    isFundamenteiTeamTemplate
    vertical
    countryCode
    dataSource
    visibility
    templateCodes
    namespace
    createdBy {
      _id
      fullName
      isSiteAdmin
      pictureUrl
    }
    useCount
    deletedAt
    archivedAt
    indicators {
      ...IndicatorFields
    }
    ...StarrableFields
    viewerCanArchive
    viewerCanDelete
    viewerCanEdit
    viewerCanChangeVisibility
    viewerCanCopy
    overrideCriteria {
      forTemplateCodes
      forPlatformVertical
    }
  }

  ${IndicatorFieldsFragment}
  ${StarrableFieldsFragment}
`;
